"use strict";

import { SideDrawerListConstants } from 'Constants/SideDrawerListConstants';
import { AppDispatcher } from 'Dispatcher';
export function sideDrawerListLoaded(list) {
  AppDispatcher.dispatch({
    actionType: SideDrawerListConstants.SIDE_DRAWER_LIST_LOADED,
    list: list
  });
}
export function sideDrawerListItemExpanded(id) {
  AppDispatcher.dispatch({
    actionType: SideDrawerListConstants.SIDE_DRAWER_LIST_ITEM_EXPANDED,
    id: id
  });
}
export function sideDrawerListItemActivate(formID) {
  AppDispatcher.dispatch({
    actionType: SideDrawerListConstants.SIDE_DRAWER_LIST_ITEM_ACTIVATE,
    formID: formID
  });
}
export function sideDrawerListUpdScrollTop(scrollTop) {
  AppDispatcher.asyncDispatch({
    actionType: SideDrawerListConstants.SIDE_DRAWER_LIST_UPDATE_SCROLL_TOP,
    scrollTop: scrollTop
  });
}